const sourceTranslator = {
  'xarid.uzex.uz': 'xarid_uzex',
  'etender.uzex.uz': 'etender',
  'tender.mc.uz': 'mc',
  'xt-xarid.uz': 'xt_xarid',
  'beeline.uz': 'beeline',
}

export { sourceTranslator }
